import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=483d0c66&"
import script from "./file-input.vue?vue&type=script&lang=js&"
export * from "./file-input.vue?vue&type=script&lang=js&"
import style0 from "./file-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports